module.exports = __webpack_public_path__ + "media/images/workstation-ae51852dbca1c5581612208be509634f.png";